import _ from 'lodash';
import React from 'react';
import Debug from 'debug';
import shallowCompare from '../../lib/shallowCompare';

const debug = Debug('delectable');

class AttributedText extends React.Component {
  static contextTypes = {
    executeAction : React.PropTypes.func
  };

  static propTypes = {
    className  : React.PropTypes.string,
    text       : React.PropTypes.string.isRequired,
    attributes : React.PropTypes.array.isRequired
  };

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  render() {
    let html = [];
    let text = this.props.text;
    let attributes = _.sortBy(this.props.attributes, (attrs) => {
      return attrs.range.start;
    });
    let condensedAttributes = [];
    let i;

    for(i=0;i<attributes.length;i++) {
      let attrs = attributes[i];
      let key = `${attrs.range.start}:${attrs.range.length}`;
      let styleKey = attrs.type;
      let styleValue = attrs.value;
      if(styleKey === 'bold') {
        styleKey = 'fontWeight';
        styleValue = 600;
      }
      let existingAttrs = _.find(condensedAttributes, (attrs) => {
        return attrs.key === key;
      });
      if(!existingAttrs) {
        existingAttrs = {
          key: key,
          start: attrs.range.start,
          length: attrs.range.length,
          style: {
            [styleKey]: styleValue
          }
        };
        condensedAttributes.push(existingAttrs);
      } else {
        existingAttrs.style[styleKey] = styleValue;
      }
    }

    for(i=0;i<condensedAttributes.length;i++) {
      let attrs = condensedAttributes[i];
      let start = attrs.start;
      let length = attrs.length;
      if(i === 0) {
        html.push(<span key={`${i}:${start}:${length}:0`}>{text.substring(0, start)}</span>);
      }
      html.push(<span key={`${i}:${start}:${length}:1`} style={attrs.style}>{text.substring(start, start + length)}</span>);
      if(i < condensedAttributes.length - 1) {
        let nextAttrs = condensedAttributes[i + 1];
        // Store plain text between current range and next range
        html.push(<span key={`${i}:${start}:${length}:2`}>{text.substring(start + length, nextAttrs.start)}</span>);
      } else {
        html.push(<span key={`${i}:${start}:${length}:3`}>{text.substring(start + length)}</span>);
      }
    }
    return <span className={this.props.className}>{html}</span>;
  }
}

export default AttributedText;



// WEBPACK FOOTER //
// banquet/components/AttributedText/index.js